import { APIGATEWAY_BASE_URL, DASHBOARD_URL } from 'src/dataLayer/env'
import { isValidBabbelReturnUrl } from 'src/dataLayer/localData/queryParams'
import makeAjaxRequest from 'src/dataLayer/remoteData/babbelAPI/makeAjaxRequest'

const ERROR_KEYS = {
  422: {
    key: 'login.b2b.error.invalid_identity_provider',
  },
  default: {
    key: 'redirectToErrorPage',
  },
}

const validateIdentityProviderAndRedirect = async (identityProvider, locale, returnTo) => {
  const data = await makeAjaxRequest({
    errorKeys: ERROR_KEYS,
    payload: {
      sso_session: {
        idp: identityProvider,
        protocol: 'saml',
      },
    },
    url: `${APIGATEWAY_BASE_URL}/v1.0.0/${locale}/authentication/sso_session`,
    verb: 'PUT',
  })

  if (data?.sso_session?.url) {
    const url = new URL(data.sso_session.url)
    const validatedReturnTo = isValidBabbelReturnUrl(returnTo) ? returnTo : DASHBOARD_URL
    url.searchParams.append('return_to', validatedReturnTo)
    globalThis.location.assign(url.href)
    // We need this to keep the button disabled while redirecting
    return { isRedirecting: true }
  }
}

export { ERROR_KEYS, validateIdentityProviderAndRedirect }
